import { videoToursService } from "client-app-core";
import * as t from "./actionTypes";

const createVideoTourAction = (id, videoTourData) => {
	return {
		type: t.CREATE_VIDEO_TOUR,
		payload: { videoTourId: id, videoTourData }
	};
};

const getAllVideoTourAction = data => {
	return {
		type: t.GET_ALL_VIDEO_TOURS,
		payload: data
	};
};

const updateVideoTourAction = (id, updatedData) => {
	return {
		type: t.UPDATE_VIDEO_TOUR,
		payload: { videoTourId: id, updatedData }
	};
};
const deleteVideoTourAction = videoTourId => {
	return {
		type: t.DELETE_VIDEO_TOUR,
		payload: { videoTourId }
	};
};

export const getAllVideoTours = () => {
	return dispatch => {
		videoToursService.getAllVideoTours((err, response) => {
			if (err) {
				console.error("Error fetching video tours:", err);
			} else if (response) {
				dispatch(getAllVideoTourAction(response));
			}
		});
	};
};

export const updateVideoTour = (videoTourId, updateData) => {
	return dispatch => {
		videoToursService.updateVideoTourById(videoTourId, updateData, (err, response) => {
			if (err) {
				console.error("Error updating video tour:", err);
			} else if (response) {
				const { id, ...updatedData } = response;
				dispatch(updateVideoTourAction(id, updatedData));
			}
		});
	};
};

export const deleteVideoTour = videoTourId => {
	return dispatch => {
		videoToursService.deleteVideoTour(videoTourId, err => {
			if (err) {
				console.error("Error deleting video tour:", err);
			}
			dispatch(deleteVideoTourAction(videoTourId));
		});
	};
};

export const streamVideoTours = () => {
	return dispatch => {
		// stream videoTours
		videoToursService.subscribeVideoTours((err, res) => {
			if (err) {
				console.log("Stream all videoTours error:", err);
			} else {
				const initVideoTourBatch = [];
				res.forEach(change => {
					if (change.type === "initial") {
						initVideoTourBatch.push(change.new_val);
					}
					if (change.type === "add") {
						const videoTour = change.new_val;

						dispatch(createVideoTourAction(videoTour.id, videoTour));
					} else if (change.type === "change") {
						const videoTour = change.new_val;

						dispatch(updateVideoTourAction(videoTour.id, videoTour));
					} else if (change.type === "remove") {
						const videoTour = change.old_val;
						dispatch(deleteVideoTourAction(videoTour.id));
					}
				});
				if (initVideoTourBatch.length > 0) {
					dispatch(getAllVideoTourAction(initVideoTourBatch));
				}
			}
		});
	};
};
